import t1 from '../assets/images/fam.jpeg';
import t2 from '../assets/images/coup.webp';
import t3 from '../assets/images/ho.jpg';
import t4 from '../assets/images/solo.jpg';

import t5 from '../assets/images/sigiriya.webp';
import t6 from '../assets/images/lep.jpg';
import t7 from '../assets/images/wo1.webp';
import t8 from '../assets/images/light.jpg';

import t9 from '../assets/images/miri2.jpg';
import t10 from '../assets/images/apri.jpg';
import t11 from '../assets/images/au.jpg';
import t12 from '../assets/images/oct.jpg';

import t13 from '../assets/images/lunub.jpg';
import t14 from '../assets/images/dishbest.webp';
import t15 from '../assets/images/well.jpg';
import t16 from '../assets/images/tu1.jpg';

export const travellerTypes = [
  {
    categoryKey: "traveller_family",
    image: t1,
  },
  {
    categoryKey: "traveller_couples",
    image: t2,
  },
  {
    categoryKey: "traveller_honeymoon",
    image: t3,
  },
  {
    categoryKey: "traveller_solo",
    image: t4,
  },
];

export const mostPopular = [
    {
    categoryKey: "popular_lion_rock",
    image: t5,
  },
  {
    categoryKey: "popular_leopard_kingdom",
    image: t6,
  },
  {
    categoryKey: "popular_worlds_end",
    image: t7,
  },
   {
    categoryKey: "popular_colonial_ramparts",
    image: t8,
  },
];

export const byMonth = [
    {
    categoryKey: "month_jan_mar",
    image: t9,
  },
    {
    categoryKey: "month_apr_jun",
    image: t10,
  },
    {
    categoryKey: "month_jul_sep",
    image: t11,
  },
    {
    categoryKey: "month_oct_dec",
    image: t12,
  },
];

export const inTheSpotlight = [
    {
    categoryKey: "spotlight_architectural",
    image: t13,
  },
    {
    categoryKey: "spotlight_culinary",
    image: t14,
  },
    {
    categoryKey: "spotlight_wellness",
    image: t15,
  },
    {
    categoryKey: "spotlight_conservation",
    image: t16,
  },
];